const MAPPING_V1: Record<string, string | null> = {
    IBackgroundModeDto: '++id,name',
    IBeaconDto: '++id,name,uuid,major,minor,siteId',
    IBeaconSensitivityDto: '++id,name',
    IFloorPlanDto:
        '++id,name,imageFileName,removeImage,imageMediumId,siteId,siteObjectsOnFloorPlanCount,styleId',
    IFontAlignmentDto: '++id,name',
    IFontFamilyDto: '++id,name',
    IFontSizeUnitDto: '++id,name',
    IFontStyleDto: '++id,name',
    ILanguageDto: '++id,name,code,isDefault',
    IMediumDto: '++id,mediumHash,fileName,mimeType,mediumSize,deleted,siteId',
    IMenuItemDto:
        '++id,name,namePropagation,imageFileName,removeImage,imageMediumId,siteId,toursCount,publishedToursCount,deleted',
    IMenuItemTranslationDto: '++id,menuItemId,languageId,name,deleted',
    IPinTypeDto: '++value,content,icon,text',
    IScreenOrientationDto: '++id,name',
    ISiteDto:
        '++id,name,logoFileName,removeLogo,logoMediumId,alarmEnabled,alarmPin,adminPin,languageSelectionMenu,tourSelectionMenu,clientId,screenOrientationId,majorVersion,minorVersion,toursCount,deviceAccountsCount,languageSelectionStyleId,tourSelectionStyleId',
    ISiteObjectOnFloorPlanDto:
        '++id,siteObjectId,floorPlanId,x,y,pinTypeId,pinColor,siteObjectName',
    ISiteObjectDto:
        '++id,name,int1,int2,int3,int4,altBoolean1,altBoolean2,isUniversal,keypadNumber,siteId,siteObjectTypeId,beaconId,beaconSensitivityId,fontSize,fontFamily,fontColor,menuPosition,nextObjectId,relatedObject1Id,relatedObject2Id,relatedObject3Id,relatedObject4Id,relatedObject5Id,removeForegroundImage,foregroundImageMediumId,foregroundImageFileName,removeBackgroundImage,backgroundImageMediumId,backgroundImageFileName,removeMenuImage,menuImageMediumId,menuImageFileName,namePropagation,longNamePropagation,descriptionPropagation,alternativeText1Propagation,alternativeText2Propagation,mediumPropagation,mediumFileName,removeMedium,backgroundColor,foregroundColor,styleId,toursCount,publishedToursCount,deleted,keywords',
    ISiteObjectTranslationDto:
        '++id,siteObjectId,languageId,name,longName,description,alternativeText1,alternativeText2,mediumId,text,deleted',
    ISiteObjectTypeDto: '++id,defaultExtensions,name',
    ISiteSupportedLanguageDto: '++id,siteId,languageId',
    IStyleDto:
        '++id,parentId,isDefault,siteId,name,description,foregroundImageMediumId,backgroundImageMediumId,backgroundColor,menuImageMediumId,backgroundModeId,menuColor,primaryFontFamilyId,primaryFontStyleId,primaryFontSize,primaryFontSizeUnitId,primaryFontColor,primaryFontAlignmentId,secondaryFontFamilyId,secondaryFontStyleId,secondaryFontSize,secondaryFontSizeUnitId,secondaryFontColor,secondaryFontAlignmentId,tertiaryFontFamilyId,tertiaryFontStyleId,tertiaryFontSize,tertiaryFontSizeUnitId,tertiaryFontColor,tertiaryFontAlignmentId,foregroundImageFileName,removeForegroundImage,menuImageFileName,removeMenuImage,backgroundImageFileName,removeBackgroundImage,hasChildren',
    ITourMenuItemDto: '++id,menuItemId,tourId,menuOrder',
    ITourRelatedSiteObjectDto: '++id,tourId,elementOrder,siteObjectId',
    ITourDto:
        '++id,name,fontColor,fontSize,fontName,backgroundColor,foregroundColor,description,siteId,tourTypeId,tourSubTypeId,styleId,tourStatusId,stage1,stage2,stage3,stage4,createdById,modifiedById,version,minorVersion,publishedVersion,testVersion',
    ITourStatusDto: '++id,name',
    ITourSubTypeDto: '++id,name,tourTypeId',
    ITourSupportedLanguageDto: '++id,siteSupportedLanguageId,tourId',
    ITourTranslationDto: '++name,completed,tourSupportedLanguageId',
    ITourTypeDto: '++id,name',
};

const MAPPING_V2: Record<string, string | null> = {
    ICountryDto: '++id,name',
    IDeviceAccountDto:
        '++id,userName,password,confirmPassword,siteId,modifiedById,isProductionUser',

    IFloorPlanTourDto: '++id,floorPlanId,tourId',
    IFloorPlanTranslationDto:
        '++id,name,imageFileName,removeImage,imageMediumId,siteId,languageId,floorPlanId,positionX,positionY,zoom,siteObjectsOnFloorPlanCount,styleId',

    IFontSizeUnitDto: '++id,name',
    ILanguageDto: '++id,name,localizedName,isDefault',

    IMenuItemDto:
        '++id,name,namePropagation,imageFileName,removeImage,imageMediumId,siteId,toursCount,publishedToursCount,deleted,menuPosition,keypadNumber,contentStyleId,menuStyleId,isBackButtonOverride,backButtonStyleId,siteObjectId,int1,int2,int3,int4,bool1,bool2,tourId,menuTypeId,menuSubTypeId',
    IMenuItemKeywordDto: '++id,name,siteId,isTag',
    IMenuItemTranslationDto:
        '++id,menuItemId,languageId,name,deleted,subMenuName,description,backgroundImageFileName,removeBackgroundImage,backgroundImageMediumId,menuImageFileName,removeMenuImage,menuImageMediumId',

    IRoleDto: '++id,name',
    IScreenOrientationDto: '++id,name,byteValue',

    ISiteDto:
        '++id,name,logoFileName,removeLogo,logoMediumId,alarmEnabled,alarmPin,adminPin,languageSelectionMenu,tourSelectionMenu,clientId,screenOrientationId,majorVersion,minorVersion,toursCount,deviceAccountsCount,languageSelectionStyleId,tourSelectionStyleId,groupingSelectionMenu,screenOrientations,contactName,title,phone,mobile,addressLine1,addressLine2,county,postalCode,countryId,notes,bluetoothEnabled,streamMedia,streamingMediaPrefixUrl,showBatteryDot,disableSpeakerOutput,grayOutContentOnPlayback,backButtonStyleId,batteryThresholdRed,batteryThresholdOrange,screensaverEnabled,screensaverShowDelay,resetInactivityDelay,alwaysShowLanguageSelection,alwaysShowTourSelection,alwaysShowGroupingSelection,showGroupingSelectionHeader,showLanguageSelectionHeader,showTourSelectionHeader,showLanguageConfirmation,resetGroupingDaily,groupingMenuEnabled,groupingShow,groupingSelectionStyleId,defaultLanguageId,groupingHeader,languageHeader,tourHeader,siteObjectOnGroupingSelectionId,siteObjectOnGroupingSelectionInitName,siteObjectOnLanguageSelectionId,siteObjectOnLanguageSelectionInitName,siteObjectOnTourSelectionId,siteObjectOnTourSelectionInitName',
    ISiteObjectDto:
        '++id,name,int1,int2,int3,int4,altBoolean1,altBoolean2,isUniversal,keypadNumber,siteId,siteObjectTypeId,beaconId,beaconSensitivityId,fontSize,fontFamily,fontColor,menuPosition,nextObjectId,relatedObject1Id,relatedObject2Id,relatedObject3Id,relatedObject4Id,relatedObject5Id,removeForegroundImage,foregroundImageMediumId,foregroundImageFileName,removeBackgroundImage,backgroundImageMediumId,backgroundImageFileName,removeMenuImage,menuImageMediumId,menuImageFileName,namePropagation,longNamePropagation,descriptionPropagation,alternativeText1Propagation,alternativeText2Propagation,mediumPropagation,mediumFileName,removeMedium,backgroundColor,foregroundColor,styleId,toursCount,publishedToursCount,deleted,screenOrientations,keywords,isSiteObjectV2,siteObjectTypeV2Id',

    ISiteObjectKeywordDto: '++id,name,siteId,isTag',

    IStyleDto:
        '++id,parentId,isDefault,siteId,name,description,foregroundImageMediumId,backgroundImageMediumId,backgroundColor,menuImageMediumId,backgroundModeId,menuColor,primaryFontFamilyId,primaryFontStyleId,primaryFontSize,primaryFontSizeUnitId,primaryFontColor,primaryFontAlignmentId,secondaryFontFamilyId,secondaryFontStyleId,secondaryFontSize,secondaryFontSizeUnitId,secondaryFontColor,secondaryFontAlignmentId,tertiaryFontFamilyId,tertiaryFontStyleId,tertiaryFontSize,tertiaryFontSizeUnitId,tertiaryFontColor,tertiaryFontAlignmentId,foregroundImageFileName,removeForegroundImage,menuImageFileName,removeMenuImage,backgroundImageFileName,removeBackgroundImage,hasChildren,primaryColor,secondaryColor,tertiaryColor,quaternaryColor',
    ITourDto:
        '++id,name,fontColor,fontSize,fontName,backgroundColor,foregroundColor,description,siteId,tourTypeId,tourSubTypeId,styleId,tourStatusId,stage1,stage2,stage3,stage4,createdById,modifiedById,version,minorVersion,publishedVersion,testVersion,internalName,grayOutContentOnPlayback,qrCode,visibilityScheduleShow,visibilityScheduleHide,siteObjectPlayOnLaunchId,showFloorplanOnMenuOnly,hideOnTourSelect,backButtonStyleId,hideKeypadNumber,screenOrientations',

    ITourRelatedSiteObjectDto:
        '++id,tourId,elementOrder,siteObjectId,menuItemId,parentTourRelatedSiteObjectId',

    ITourTranslationDto:
        '++name,completed,tourSupportedLanguageId,mediumId,mediumFileName,removeMedium',

    ITourSupportedLanguageDto: '++id,siteSupportedLanguageId,tourId,languageId',
    IUserDto:
        '++id,userName,firstName,lastName,avatarFileName,removeAvatar,avatar,avatarMimeType,isCmsUser,emailConfirmed,siteId,managedClientId,managedSiteId,modifiedById,mainRole,workingForClientId,mainRoleHR',
    ILegacy_FloorPlanDto:
        '++id,name,imageFileName,removeImage,imageMediumId,siteId,siteObjectsOnFloorPlanCount,styleId',
};

/* Migration is split across 3 stages,
  #1 We need to move all the data to a new table & Delete the old
  #2 Recreate the new table, move the data in & delete the tmp table
  One does not simply change the primaryKey. Refs: 
    https://github.com/dexie/Dexie.js/issues/646#issuecomment-359460164, 
    https://github.com/dexie/Dexie.js/blob/issue713/test/tests-upgrading.js#L568-L604
*/
const MAPPING_V3: Record<string, string | null> = {
    ITourTranslationDto: null,
    ITourTranslationDto_tmp:
        '++tourSupportedLanguageId,name,completed,mediumId,mediumFileName,removeMedium',
};

const MAPPING_V4: Record<string, string | null> = {
    ITourTranslationDto:
        '++tourSupportedLanguageId,name,completed,mediumId,mediumFileName,removeMedium',
    ITourTranslationDto_tmp: null,
};

const MAPPING_V5: Record<string, string | null> = {
    ISiteObjectOnFloorPlanDto: null,
    ISiteObjectOnFloorPlanDto_tmp:
        '[siteObjectId+floorPlanId],x,y,pinTypeId,pinColor,siteObjectName',
};

const MAPPING_V6: Record<string, string | null> = {
    ISiteObjectOnFloorPlanDto: '[siteObjectId+floorPlanId],x,y,pinTypeId,pinColor,siteObjectName',
    ISiteObjectOnFloorPlanDto_tmp: null,
};

export type VERSION = 1 | 2 | 3 | 4 | 5 | 6;

const MappedVersions: Record<VERSION, Record<string, string | null>> = {
    1: MAPPING_V1,
    2: MAPPING_V2,
    3: MAPPING_V3,
    4: MAPPING_V4,
    5: MAPPING_V5,
    6: MAPPING_V6,
};

const Mapping = (version: VERSION): Record<string, string | null> => MappedVersions[version];

export default Mapping;
